<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-12 15:46:03
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
-->
<template>
	<div>
		<el-popover :disabled="!skuList.length" placement="bottom-start" width="354" trigger="hover" v-model="visible">
			<div v-if="visible">
				<div>
					<p class="yx-color-pure-1 fz-14">商品规格</p>
					<p class="fz-12 yx-color-text-p-4 mt-8" v-if="$isKs(row.platform_id)">
						<i class="el-icon-info"></i>
						<span style="margin-left: 2px">快手官方暂未提供商品规格图片，以下均展示商品主图。</span>
					</p>
				</div>
				<el-table class="table" header-row-class-name="table-header-sku" row-class-name="table-row" :data="skuList">
					<el-table-column label="商品图" width="96">
						<template v-slot="{ row }">
							<div>
								<el-avatar :size="40" :src="row.image_url" shape="square"></el-avatar>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="规格名称">
						<template v-slot="{ row }">
							<rd-text :useByTable="false" class="yx-color-text-p-4 fz-12">{{ row.specification }}</rd-text>
						</template>
					</el-table-column>
					<el-table-column label="规格ID">
						<template v-slot="{ row }">
							<rd-text :useByTable="false" class="yx-color-text-p-4 fz-12">{{ row.outer_sku_id }}</rd-text>
						</template>
					</el-table-column>
					<el-table-column label="现售价" width="80">
						<template v-slot="{ row }">
							<div class="yx-color-text-p-4 fz-12">
								{{ row.price | formatEmpty | formatPrice }}
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="fz-14 yx-color-text-primary line-clamp-3" slot="reference">
				{{ skuName }}
			</div>
		</el-popover>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	data() {
		return {
			visible: false,
		};
	},
	components: {},
	computed: {
		skuList({ row }) {
			return row.sku_list || [];
		},
		skuName({ skuList }) {
			if (!skuList.length) {
				return '-';
			}
			return skuList.map(item => item.specification).join('、');
		},
	},
};
</script>
<style lang="less" scoped>
::v-deep .el-table__body-wrapper {
	max-height: 252px;
	overflow-y: auto;
	&::-webkit-scrollbar {
		width: 6px;
	}
	&::-webkit-scrollbar-thumb {
		height: 26px;
		border-radius: 3px;
		background-color: @border-color-lighter;
	}
}
.table::before {
	height: 0 !important;
}
::v-deep .table-header-sku th {
	border-bottom: 1px solid #f0f1f5 !important;
}
</style>
